import { render, staticRenderFns } from "./MyAppraisals.vue?vue&type=template&id=25a9dda8"
import script from "./MyAppraisals.vue?vue&type=script&lang=js"
export * from "./MyAppraisals.vue?vue&type=script&lang=js"
import style0 from "./MyAppraisals.vue?vue&type=style&index=0&id=25a9dda8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports